<!-- Switcher -->
<div class="switcher-wrapper">
    <div class="demo_changer">
        <div class="demo-icon bg_dark">
            <i class="fa fa-cog fa-spin  text_primary"></i>
        </div>
        <div class="form_holder sidebar-right1">
            <div class="row">
                <div class="predefined_styles">
                    <div class="swichermainleft text-center">
                        <div class="p-3">
                            <a href="https://angular.spruko.com/spruha/" class="btn btn-primary btn-block mt-0">View Demo</a>
                            <a href="https://themeforest.net/item/spruha-angular-admin-dashboard-template/30939314?s_rank=3" class="btn btn-secondary btn-block">Buy Now</a>
                            <a href="https://1.envato.market/MGEaN" class="btn btn-info btn-block">Our Portfolio</a>
                        </div>
                    </div>
                    <div class="swichermainleft mb-4">
                        <h4>Navigation Style</h4>
                        <div class="ps-3 pe-3 pt-3">
                            <a class="btn btn-primary btn-block" href="https://angular.spruko.com/spruha/Horizontal/"> Horizontal </a>
                            <a class="btn btn-secondary btn-block" href="https://angular.spruko.com/spruha/Vertical/"> Leftmenu</a>
                        </div>
                    </div>
                    <div class="swichermainleft mb-4">
                        <h4>Sidemenu Layout width Styles</h4>
                        <div class="skin-body">
                            <div class="switch_section">
                                <div class="switch-toggle d-flex mt-4">
                                    <span class="me-auto">Default Sidebar</span>
                                    <a class="onoffswitch2"><input type="radio" name="onoffswitch5" id="myonoffswitch18"
                                            class="onoffswitch2-checkbox" checked>
                                        <label for="myonoffswitch18" class="onoffswitch2-label"></label>
                                    </a>
                                </div>
                                <div class="switch-toggle d-flex mt-2">
                                    <span class="me-auto">Boxed</span>
                                    <a class="onoffswitch2"><input type="radio" name="onoffswitch5" id="myonoffswitch19"
                                            class="onoffswitch2-checkbox">
                                        <label for="myonoffswitch19" class="onoffswitch2-label"></label>
                                    </a>
                                </div>
                                <div class="switch-toggle d-flex mt-2">
                                    <span class="me-auto">RTL</span>
                                    <a class="onoffswitch2"><input type="checkbox" name="onoffswitch5"
                                            id="myonoffswitch55" class="onoffswitch2-checkbox">
                                        <label for="myonoffswitch55" class="onoffswitch2-label"></label>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="swichermainleft">
                        <h4 class="font-bold text-sm me-3">Default Theme Switcher</h4>
                        <div class="swichermainleft my-4">
                            <a class="wscolorcode red-btn color blackborder color1" href="javascript:;"
                                data-theme="./assets/css/colors/color1.css"></a>
                            <a class="wscolorcode purple-btn color blackborder color2" href="javascript:;"
                                data-theme="./assets/css/colors/color2.css"></a>
                            <a class="wscolorcode green-btn color blackborder color3" href="javascript:;"
                                data-theme="./assets/css/colors/color3.css"></a>
                            <a class="wscolorcode pink-btn color blackborder color4" href="javascript:;"
                                data-theme="./assets/css/colors/color4.css"></a>
                            <a class="wscolorcode orange-btn color blackborder color5" href="javascript:;"
                                data-theme="./assets/css/colors/color5.css"></a>
                        </div>
                    </div>
                    <div class="swichermainleft">
                        <h4>Ions Styles</h4>
                        <div class="switch_section my-2">
                            <div class="switch-toggle d-flex">
                                <span class="me-auto">Icon Style</span>
                                <div class="onoffswitch2">
                                    <input type="checkbox" name="onoffswitch2" id="myonoffswitch51"
                                        class="onoffswitch2-checkbox">
                                    <label for="myonoffswitch51" class="onoffswitch2-label"></label>
                                </div>
                            </div>
                        </div>
                        <div class="switch_section my-2">
                            <div class="switch-toggle d-flex">
                                <span class="me-auto">Theme Style</span>
                                <div class="onoffswitch2">
                                    <input type="checkbox" name="onoffswitch2" id="myonoffswitch52"
                                        class="onoffswitch2-checkbox">
                                    <label for="myonoffswitch52" class="onoffswitch2-label"></label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="swichermainleft">
                        <h4>Theme Layout</h4>
                        <div class="switch_section d-flex my-4">
                            <div class="d-block text-center mx-auto">
                                <button type="button" id="background5"
                                    class="bg5 mb-3 wscolorcode1 blackborder"></button>
                                <span class="badge bg-light tx-12">Dark layout</span>
                            </div>
                            <div class="d-block text-center mx-auto">
                                <button type="button" id="background6"
                                    class="bg6 mb-3 wscolorcode1 blackborder"></button>
                                <span class="badge bg-light tx-12">Light layout</span>
                            </div>
                        </div>
                    </div>
                    <div class="swichermainleft">
                        <h4>Header Styles Mode</h4>
                        <div class="switch_section d-flex my-4">
                            <div class="d-block text-center mx-auto">
                                <button type="button" id="background3"
                                    class="bg3 mb-3 wscolorcode1 blackborder"></button>
                                <span class="badge bg-light tx-12">Dark Header</span>
                            </div>
                            <div class="d-block text-center mx-auto">
                                <button type="button" id="background4"
                                    class="bg4 mb-3 wscolorcode1 blackborder"></button>
                                <span class="badge bg-light tx-12">Color Header</span>
                            </div>
                        </div>
                    </div>
                    <div class="swichermainleft">
                        <h4>Leftmenu Styles Mode</h4>
                        <div class="switch_section d-flex my-4">
                            <div class="d-block text-center mx-auto">
                                <button type="button" id="background1" class="bg1 wscolorcode1 blackborder"></button>
                                <span class="badge bg-light tx-12">Color Menu</span>
                            </div>
                            <div class="d-block text-center mx-auto">
                                <button type="button" id="background2" class="bg2 wscolorcode1 blackborder"></button>
                                <span class="badge bg-light tx-12">Light Menu</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Switcher -->